import script from "./StreaksHomeCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./StreaksHomeCard.vue?vue&type=script&lang=ts&setup=true"

import "./StreaksHomeCard.vue?vue&type=style&index=0&id=5b91496b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b91496b"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears});
